const sidebar = document.querySelector('#sidebar-cart')
const spinner = document.createElement('div')
spinner.classList.add('spinner')

const fetcher = async (url, config = {}) => {
  try {
    if(config.body) config.body = JSON.stringify(config.body)
    config.headers = {"content-type": "application/json"}
    const req = await fetch(url,config)
    const res = await req.json()
    await window.CartSection._rerenderCart()
    return res
  } catch(err) {
    throw err
  }
}

const addBag = async () => {
  await fetcher(`${window.routes.cartUrl}/add.js`,{
    method: "POST",
    body: {
      items: [{
        id: bagID,
        quantity: 1
      }]
    }
  })
  spinner.remove()
}

const removeBag = async () => {
  await fetcher(`${window.routes.cartUrl}/update.js`,{
    method: "POST",
    body: {
      updates: {
        [bagID]: 0
      }
    }
  })
}

if(sidebar) {
  sidebar.addEventListener('change', async e => {
    if(e.target.id !== 'add-gift-bag') return

    const previous = sidebar.querySelector(`[data-variant="${bagID}"]`)
    if(!previous) {
      sidebar.appendChild(spinner)
      return addBag()
    }
    const remove = previous.querySelector('[data-action="remove-item"]')
    if(remove) remove.click()
  }, false)
}
